module.exports = __webpack_public_path__ + "static/young-leader-photo-jasmine_hasmatali-f4a4966870fe69ee3ace4c2c2c97c96d.jpg";